export default __webpack_public_path__ + "static/media/Srikanth.d86258e9.svg";